export default function useTitle() {
  const setTitle = ({ segments = [], separator = '' }) => {
    document.title = segments.join(separator);
  };

  return {
    setTitle,
  };
}
